import { VStack } from "@/components/ui/vstack";
import { Text } from "@/components/ui/text";
import { Pressable } from "@/components/ui/pressable";
import { Menu, MenuItem, MenuItemLabel } from "@/components/ui/menu";
import { Image } from "@/components/ui/image";
import { HStack } from "@/components/ui/hstack";
import { Box } from '@/components/ui/box';
import i18n from 'i18n-js';
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ImageSynced from "@/components/media/ImageSynced";
import { logos } from '@/assets/images';
import { studioVersion } from "@/studio/algorithms_and_functions/studioVersion";
import { IconM } from '@/components/media/IconsV2';
import ModalAccount from '@/studio/components/modals/ModalAccount';
import { logout } from "@/stores/mainSlice";
import OpenIssueButton from "@/components/basic/OpenIssueButton";

export default function Header({ navigation, options }) {
    const inAColor = useSelector((state) => state.settings.inAColor == undefined ? 0 : state.settings.inAColor)
    const user = useSelector((state) => state.user)
    const imgLoad = useSelector((state) => state.images.load)
    const commit = useSelector((state) => state.commit || '-')
    const dispatch = useDispatch()
    const internal = useSelector((state) => state.settings.preview)

    console.log('XXZ', internal)

    let [showAccount, setShowAccount] = useState(false);

    // 
    const AccountMenu = () => {
        return (
            <Menu placement='bottom left' trigger={triggerProps => {
                return (
                    <Pressable {...triggerProps}>
                        <HStack space='xs' className="items-center">
                            <ImageSynced key={user.avatar + '_' + imgLoad[user.avatar]?.duration + '_' + user.updated} uri={user.avatar} refresh={user.updated} isAvatar={true} className='border-secondary-50 border bg-secondary-50' size='md' />
                            <Text className="text-md text-secondary-50">{user.name}</Text>
                            <IconM className='text-secondary-50' size={24} name='keyboard-arrow-down' />
                        </HStack>
                    </Pressable>
                );
            }}>
                <MenuItem onPress={() => { setShowAccount(true) }} textValue={i18n.t('sideNavigationDrawer.accountSettings')}>
                    <MenuItemLabel className="text-tg">{i18n.t('sideNavigationDrawer.accountSettings')}</MenuItemLabel>
                </MenuItem>
                <MenuItem onPress={() => { dispatch(logout({ clean: true })) }} textValue={i18n.t('sideNavigationDrawer.logout')}>
                    <MenuItemLabel className="text-tg">{i18n.t('sideNavigationDrawer.logout')}</MenuItemLabel>
                </MenuItem>
                {internal &&
                    <MenuItem textValue={commit}>
                        <MenuItemLabel className="text-tg">{i18n.t('appSettings.commit') + ' ' + commit}</MenuItemLabel>
                    </MenuItem>}
            </Menu>
        );
    }

    return (
        <HStack space='xs' className="items-center justify-between bg-primary-900 h-[60px] px-6">
            <Image source={logos[inAColor]} alt={i18n.t('global.missingImage')} className="w-[60px] h-[60px]" />
            {internal && <VStack>
                <Box className={`mr-4 border-[2px] border-white bg-white rounded-full mt-1 `}>
                    <OpenIssueButton navigation={navigation} icon='bug' />
                </Box>
            </VStack>}
            <VStack className="flex-1 mr-3 px-2">
                <Text className="text-2xl text-secondary-50 mt-0">{options.title}</Text>
                <Text isTruncated={true} className="max-w-full text-lg text-secondary-50 mt-1">{options.info}</Text>
            </VStack>
            {!options.basic &&
                <HStack space='xs' className="self-center items-center">
                    <AccountMenu />
                    <Text className="-rotate-90 text-md text-secondary-50">{studioVersion}</Text>
                </HStack>
            }
            <ModalAccount showModal={showAccount} setShowModal={setShowAccount} />
        </HStack>
    );
}
